import ValuerAmendSubtitle from "./ValuerAmendSubtitle";
import ValuerAmendRadio from "./ValuerAmendRadio";
import ValuerAmendFreeTextInput from "./ValuerAmendFreeTextInput";
import ValuerAmendColumnContainer from "./ValuerAmendColumnContainer";
import ValuerAmendFileInput from "./ValuerAmendFileInput";
import ValuerAmendMultiSelect from "./ValuerAmendMultiSelect";
import ValuerAmendDateInput from "./ValuerAmendDateInput";
import ValueAmendTableContainer from "./ValueAmendTableContainer";
import ValuerAmendPriceInput from "./ValuerAmendPriceInput";
import ValuerAmendTitle from "./ValuerAmendTitle";
import ValuerAmendNote from "./ValuerAmendNote";
import ValueAmendPasteableTableContainer from "./ValueAmendPasteableTableContainer";
import ValuerAmendCustomAdditionsContainer from "./ValuerAmendCustomAdditionsContainer";
import ValuerAmendAppendicesContainer from "./ValuerAmendAppendicesContainer";
import ValuerAmendLinks from "./ValuerAmendLinks";
import ValuerAmendPreviewContainer from "./ValuerAmendPreviewContainer";
import ValuerAmendValueDependantField from "./ValuerAmendValueDependantField";
import ValuerAmendIntegerInput from "./ValuerAmendIntegerInput";
import ValuerAmendBlockText from "./ValuerAmendBlockText";
import ValuerAmendExpandableTableContainer from "./ValuerAmendExpandableTableContainer"
import ValuerAmendCustomAdditionComponent from "./ValuerAmendCustomAdditionComponent"

const ValuerAmendFieldListHandler = (props) => {

    const summaryId = props.summaryId
    const sectionName = props.sectionName
    const fieldList = props.fieldList

    // Value to be passed through
    const values = props.values

    // Optional Row ID:
    const rowId = props.rowId ? props.rowId : false

    // Functions
    const UpdateParentValue = props.UpdateParentValue
    const GetValueFromGrandParentValues = props.GetValueFromGrandParentValues
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    const GetValueFromValues = (_ident) => {
        if (!values) return null;

        if (rowId) {
            const rowValues = values[rowId];
            if (rowValues && typeof rowValues === "object" && _ident in rowValues) {
                return rowValues[_ident];
            }
            return null;
        }

        if (_ident in values) {
            return values[_ident];
        }

        return null;
    };

    const GetValuesFromValues = (_idents) => {
        if (!Array.isArray(_idents)) return [];

        return _idents.map(ident => {
            if (rowId) {
                const rowValues = values?.[rowId];
                return rowValues?.[ident] ?? "";
            }
            return values?.[ident] ?? "";
        });
    };



    const UpdateParentValueTest = (param, p, o) => {
        UpdateParentValue(param, p, o)
    }

    return (
        <>
            {fieldList && fieldList.map((field) => {
                if (field.type === 'subtitle') return (
                    <ValuerAmendSubtitle value={field.value} id={field.identifier}/>
                )
                else if (field.type === 'title') return (
                    <ValuerAmendTitle value={field.value} id={field.identifier}/>
                )
                else if (field.type === 'note') return (
                    <ValuerAmendNote value={field.value} id={field.identifier}/>
                )
                else if (field.type === 'links') return (
                    <ValuerAmendLinks links={GetValueFromValues(field.identifier)} flex={field.flex} id={field.identifier}/>
                )
                else if (field.type === 'preview') return (
                    <ValuerAmendPreviewContainer valuesIdentifiers={field.valuesIdentifiers}
                                                 GetValuesFromValues={GetValuesFromValues}
                                                 valuesOptions={field.valuesOptions}
                                                 text={field.text}
                                                 field={field.field}
                                                 id={field.identifier}
                                                 currentValues={values} />
                )
                else if (field.type === 'divider') return (
                    <div className="valuer-amend-diving-line" id={field.identifier}/>
                )
                else if (field.type === 'radio') return (
                    <ValuerAmendRadio id={field.identifier}
                                      summaryId={summaryId}
                                      sectionName={sectionName}
                                      identifier={field.identifier}
                                      field={field.field}
                                      fieldInfo={field.fieldInfo}
                                      infoColor={field.infoColor}
                                      options={field.options}
                                      flex={field.flex}
                                      optionsFlex={field.optionsFlex}
                                      disableMargin={field.disableMargin}
                                      valueDependantFields={field.valueDependantFields}
                                      optionRequiresDescription={field.optionRequiresDescription}
                                      descriptionIdentifier={field.descriptionIdentifier}
                                      showValueDependantFields={field.showValueDependantFields}
                                      value={
                                          ["flood-zone", "flood-zone-surface-water", "flood-zone-rivers-sea"].includes(field.identifier)
                                              ? (() => {
                                                  const raw = GetValueFromValues(field.identifier)
                                                  try {
                                                      return JSON.parse(raw)
                                                  } catch (e) {
                                                      return raw
                                                  }
                                              })()
                                              : GetValueFromValues(field.identifier)
                                      }
                                      descriptionValue={GetValueFromValues(field.descriptionIdentifier)}
                                      sectionValues={values}
                                      UpdateParentValue={UpdateParentValue}
                                      AddToQueue={AddToQueue}
                                      RemoveFromQueue={RemoveFromQueue}
                                      AddToErroredSaves={AddToErroredSaves}
                                      setErrorMessage={setErrorMessage}
                                      setErrorTitle={setErrorTitle}
                    />
                )
                else if (field.type === 'date') return (
                    <ValuerAmendDateInput id={field.identifier}
                                              rowId={rowId}
                                              summaryId={summaryId}
                                              sectionName={sectionName}
                                              identifier={field.identifier}
                                              field={field.field}
                                              width={field.width}
                                              height={field.height}
                                              minHeight={field.minHeight}
                                              minWidth={field.minWidth}
                                              value={GetValueFromValues(field.identifier)}
                                              showValueDependantFields={field.showValueDependantFields}
                                              valueDependantFields={field.valueDependantFields}
                                              UpdateParentValue={UpdateParentValue}
                                              AddToQueue={AddToQueue}
                                              RemoveFromQueue={RemoveFromQueue}
                                              AddToErroredSaves={AddToErroredSaves}
                                              setErrorMessage={setErrorMessage}
                                              setErrorTitle={setErrorTitle}
                    />
                )
                else if (field.type === 'price') return (
                    <ValuerAmendPriceInput id={field.identifier}
                                           rowId={rowId}
                                           summaryId={summaryId}
                                           sectionName={sectionName}
                                           identifier={field.identifier}
                                           field={field.field}
                                           placeholder={field.placeholder}
                                           width={field.width}
                                           height={field.height}
                                           minHeight={field.minHeight}
                                           minWidth={field.minWidth}
                                           value={GetValueFromValues(field.identifier)}
                                           showValueDependantFields={field.showValueDependantFields}
                                           valueDependantFields={field.valueDependantFields}
                                           UpdateParentValue={UpdateParentValue}
                                           AddToQueue={AddToQueue}
                                           RemoveFromQueue={RemoveFromQueue}
                                           AddToErroredSaves={AddToErroredSaves}
                                           setErrorMessage={setErrorMessage}
                                           setErrorTitle={setErrorTitle}

                    />
                )
                else if (field.type === 'freetext') return (
                    <ValuerAmendFreeTextInput id={field.identifier}
                                              rowId={rowId}
                                              summaryId={summaryId}
                                              sectionName={sectionName}
                                              identifier={field.identifier}
                                              field={field.field}
                                              placeholder={field.placeholder}
                                              fieldInfo={field.fieldInfo}
                                              infoColor={field.infoColor}
                                              width={field.width}
                                              height={field.height}
                                              minHeight={field.minHeight}
                                              minWidth={field.minWidth}
                                              textLimit={field.textLimit}
                                              flex={field.flex}
                                              disabled={field.disabled}
                                              value={GetValueFromValues(field.identifier)}
                                              sectionValues={values}
                                              defaultValue={field.defaultValue}
                                              showValueDependantFields={field.showValueDependantFields}
                                              valueDependantFields={field.valueDependantFields}
                                              UpdateParentValue={UpdateParentValue}
                                              AddToQueue={AddToQueue}
                                              RemoveFromQueue={RemoveFromQueue}
                                              AddToErroredSaves={AddToErroredSaves}
                                              setErrorMessage={setErrorMessage}
                                              setErrorTitle={setErrorTitle}
                    />
                )
                else if (field.type === 'file') return (
                    <ValuerAmendFileInput id={field.identifier}
                                          rowId={rowId}
                                          summaryId={summaryId}
                                          sectionName={sectionName}
                                          identifier={field.identifier}
                                          field={field.field}
                                          input={field.input}
                                          delete={field.delete}
                                          fileCount={field.fileCount}
                                          requiredFiles={field.requiredFiles}
                                          notes={field.notes}
                                          fileHeight={field.fileHeight}
                                          fileWidth={field.fileWidth}
                                          UpdateParentValue={UpdateParentValue}
                                          AddToQueue={AddToQueue}
                                          RemoveFromQueue={RemoveFromQueue}
                                          AddToErroredSaves={AddToErroredSaves}
                                          setErrorMessage={setErrorMessage}
                                          setErrorTitle={setErrorTitle}
                    />
                )
                else if (field.type === 'columns') return (
                    <ValuerAmendColumnContainer id={field.identifier}
                                                fieldList={field.fields}
                                                disableMargin={field.disableMargin}
                                                values={values}
                                                summaryId={summaryId}
                                                sectionName={sectionName}
                                                setErrorMessage={setErrorMessage}
                                                setErrorTitle={setErrorTitle}
                                                UpdateParentValue={UpdateParentValue}
                                                AddToQueue={AddToQueue}
                                                RemoveFromQueue={RemoveFromQueue}
                                                AddToErroredSaves={AddToErroredSaves}
                    />
                )
                else if (field.type === 'multiselect') {
                    return (
                        <ValuerAmendMultiSelect id={field.identifier}
                                                summaryId={summaryId}
                                                sectionName={sectionName}
                                                identifier={field.identifier}
                                                field={field.field}
                                                options={field.options}
                                                flex={field.flex}
                                                customInput={field.customInput}
                                                customInputButtonText={field.customInputButtonText}
                                                optionsFlex={field.optionsFlex}
                                                showValueDependantFields={field.showValueDependantFields}
                                                valueDependantFields={field.valueDependantFields}
                                                value={GetValueFromValues(field.identifier)}
                                                defaultValue={field.defaultValue}
                                                UpdateParentValue={UpdateParentValue}
                                                AddToQueue={AddToQueue}
                                                RemoveFromQueue={RemoveFromQueue}
                                                AddToErroredSaves={AddToErroredSaves}
                                                setErrorMessage={setErrorMessage}
                                                setErrorTitle={setErrorTitle}

                        />
                    )
                }
                else if (field.type === 'table') return (
                    <ValueAmendTableContainer id={field.identifier}
                                              summaryId={summaryId}
                                              sectionName={sectionName}
                                              identifier={field.identifier}
                                              rows={field.rows}
                                              columns={field.columns}
                                              rowHeight={field.rowHeight}
                                              values={GetValueFromValues(field.identifier)}
                                              setErrorMessage={setErrorMessage}
                                              setErrorTitle={setErrorTitle}
                                              UpdateParentValue={UpdateParentValue}
                                              AddToQueue={AddToQueue}
                                              RemoveFromQueue={RemoveFromQueue}
                                              AddToErroredSaves={AddToErroredSaves}
                    />
                )
                else if (field.type === 'custom-addition-fields') return (
                    <ValuerAmendCustomAdditionsContainer id={field.identifier}
                                                         key={JSON.stringify(GetValueFromValues(field.identifier) || {})}
                                                         values={GetValueFromValues(field.identifier)}
                                                         fieldList={field.fields}
                                                         fieldTitles={field.fieldTitles}
                                                         buttonText={field.buttonText}
                                                         summaryId={summaryId}
                                                         sectionName={sectionName}
                                                         identifier={field.identifier}
                                                         setErrorMessage={setErrorMessage}
                                                         setErrorTitle={setErrorTitle}
                                                         UpdateParentValue={UpdateParentValue}
                                                         AddToQueue={AddToQueue}
                                                         RemoveFromQueue={RemoveFromQueue}
                                                         AddToErroredSaves={AddToErroredSaves}
                    />
                )
                else if (field.type === 'appendices') return (
                    <ValuerAmendAppendicesContainer id={field.identifier}
                                                    values={GetValueFromValues(field.identifier)}
                                                    summaryId={summaryId}
                                                    sectionName={sectionName}
                                                    identifier={field.identifier}
                                                    field={rowId && rowId !== 1 ? null : field.field}
                                                    notes={field.notes}
                                                    fileHeight={field.fileHeight}
                                                    fileWidth={field.fileWidth}
                                                    files={GetValueFromValues(field.identifier)}
                                                    UpdateParentValue={UpdateParentValueTest}
                                                    AddToQueue={AddToQueue}
                                                    RemoveFromQueue={RemoveFromQueue}
                                                    AddToErroredSaves={AddToErroredSaves}
                                                    setErrorMessage={setErrorMessage}
                                                    setErrorTitle={setErrorTitle}

                    />
                )
                else if (field.type === 'pasteable-table') return (
                    <ValueAmendPasteableTableContainer id={field.identifier}
                                                       summaryId={summaryId}
                                                       sectionName={sectionName}
                                                       identifier={field.identifier}
                                                       rows={field.rows}
                                                       columns={field.columns}
                                                       addRows={field.addRows}
                                                       deleteRows={field.deleteRows}
                                                       sideBarMenu={field.sideBarMenu}
                                                       addButtonText={field.addButtonText}
                                                       rowHeight={field.rowHeight}
                                                       blankRows={field.blankRows}
                                                       values={GetValueFromValues(field.identifier)}
                                                       defaultValue={field.defaultValue}
                                                       setErrorMessage={setErrorMessage}
                                                       setErrorTitle={setErrorTitle}
                                                       UpdateParentValue={UpdateParentValue}
                                                       AddToQueue={AddToQueue}
                                                       RemoveFromQueue={RemoveFromQueue}
                                                       AddToErroredSaves={AddToErroredSaves}
                    />
                )
                else if (field.type === 'expandable-table') return (
                    <ValuerAmendExpandableTableContainer id={field.identifier}
                                                       summaryId={summaryId}
                                                       sectionName={sectionName}
                                                       identifier={field.identifier}
                                                       rows={field.rows}
                                                       columns={field.columns}
                                                       addRows={field.addRows}
                                                       deleteRows={field.deleteRows}
                                                       sideBarMenu={field.sideBarMenu}
                                                       addButtonText={field.addButtonText}
                                                       rowHeight={field.rowHeight}
                                                       blankRows={field.blankRows}
                                                       values={GetValueFromValues(field.identifier)}
                                                       defaultValue={field.defaultValue}
                                                       setErrorMessage={setErrorMessage}
                                                       setErrorTitle={setErrorTitle}
                                                       UpdateParentValue={UpdateParentValue}
                                                       AddToQueue={AddToQueue}
                                                       RemoveFromQueue={RemoveFromQueue}
                                                       AddToErroredSaves={AddToErroredSaves}
                    />
                )
                else if (field.type === 'value-dependant') return (
                    <ValuerAmendValueDependantField id={field.identifier}
                                                    valueDependantFields={field.valueDependantFields}
                                                    GetValueFromGrandParentValues={GetValueFromGrandParentValues}
                                                    values={values}
                                                    rowId={rowId}
                                                    summaryId={summaryId}
                                                    sectionName={sectionName}
                                                    UpdateParentValue={UpdateParentValue}
                                                    AddToQueue={AddToQueue}
                                                    RemoveFromQueue={RemoveFromQueue}
                                                    AddToErroredSaves={AddToErroredSaves}
                                                    setErrorMessage={setErrorMessage}
                                                    setErrorTitle={setErrorTitle}
                    />
                )
                else if (field.type === 'integer') return (
                    <ValuerAmendIntegerInput id={field.identifier}
                                              rowId={rowId}
                                              summaryId={summaryId}
                                              sectionName={sectionName}
                                              identifier={field.identifier}
                                              field={field.field}
                                              placeholder={field.placeholder}
                                              fieldInfo={field.fieldInfo}
                                              infoColor={field.infoColor}
                                              width={field.width}
                                              height={field.height}
                                              minHeight={field.minHeight}
                                              minWidth={field.minWidth}
                                              textLimit={field.textLimit}
                                              flex={field.flex}
                                              value={GetValueFromValues(field.identifier)}
                                              defaultValue={field.defaultValue}
                                              UpdateParentValue={UpdateParentValue}
                                              AddToQueue={AddToQueue}
                                              RemoveFromQueue={RemoveFromQueue}
                                              AddToErroredSaves={AddToErroredSaves}
                                              setErrorMessage={setErrorMessage}
                                              setErrorTitle={setErrorTitle}
                    />
                )
                else if (field.type === 'blockText') return (
                    <ValuerAmendBlockText id={field.identifier}
                                             rowId={rowId}
                                             summaryId={summaryId}
                                             sectionName={sectionName}
                                             identifier={field.identifier}
                                             field={field.field}
                                             color={field.color}
                                             font={field.font}
                    />
                )
                else if (field.type === 'custom-addition-component') return (
                    <ValuerAmendCustomAdditionComponent
                        id={field.identifier}
                        rowId={rowId}
                        summaryId={summaryId}
                        sectionName={sectionName}
                        identifier={field.identifier}
                        field={field.field}
                        values={values}
                        color={field.color}
                        font={field.font}
                        AddToQueue={AddToQueue}
                        RemoveFromQueue={RemoveFromQueue}
                        AddToErroredSaves={AddToErroredSaves}
                        UpdateParentValue={UpdateParentValue}
                    />

                )
                else return (<></>)
            })}
        </>
    )
}

export default ValuerAmendFieldListHandler